import {Component, OnDestroy, OnInit} from '@angular/core';
import {TopMenuService} from './top-menu.service';
import {LoginService} from '../login/login.service';
import {MenuPosition} from '../../model/menu-position';
import {NotifierService} from '../notifier/notifier.service';
import {NotificationType} from '../notifier/notification-type.enum';
import {Router} from '@angular/router';
import {LoginEvent} from '../../model/login-event';
import {HeaderService} from "../header/header.service";
import {MainMenuService} from "../header/main-menu/main-menu.service";
import {SingleReportService} from "../single-report/single-report.service";
import {UserSuggestedReportsService} from "../user-suggested-reports/user-suggested-reports.service";
import {UserSearchResultsService} from "../user-search-results/user-search-results.service";
import { BreadcumbsService } from '../breadcumbs/breadcumbs.service';
import {SearchItem} from "../../model/search-item";
import { CommonService } from '../../common/common.service';
import {TopMenuPositionType} from "../../common/top-menu-position-type.enum";
import {saveAs} from "file-saver";


@Component({
  selector: 'pbc-top-menu',
  templateUrl: './top-menu.component.html',
  styleUrls: ['./top-menu.component.scss']
})
export class TopMenuComponent implements OnInit, OnDestroy {

  protected menuPositions: Array<MenuPosition> = [];
  protected menuMarkedAsNew : Array<number> = [];

  protected activePosition: number = 0;
  protected mouseOverPosition : number = -1;

  //Zapisane raporty
  protected userReportsCount : number = 0;

  isUserLogged: boolean = false;
  isAdmin: boolean = false;
  isClient : boolean = false;

  mainMenuTourContent = "";

  searchItemsSelected = [];
  searchItems : Array<SearchItem> = [];

  constructor(private topMenuService: TopMenuService,
              private loginService: LoginService,
              private notifierService : NotifierService,
              private headerService : HeaderService,
              private mainMenuService  : MainMenuService,
              private singleReportService : SingleReportService,
              private userSuggestedReportsService : UserSuggestedReportsService,
              private userSearchResultsService : UserSearchResultsService,
              private breadcumbsService: BreadcumbsService,
              private commonService: CommonService, 
              private router : Router) {


    this.topMenuService.userReportsCount.subscribe((result :  number) => {
      this.userReportsCount = result;
      this.updateSavedReportsLabel(this.userReportsCount);
    });
  }

  private updateSavedReportsLabel(savedReports:number) {
    for (let menuPosition of this.menuPositions)
      if (menuPosition.position_type === TopMenuPositionType.SAVED_REPORTS) {
        if (savedReports)
          menuPosition.label = "Zapisane (".concat(savedReports.toString(),")");
        else
          menuPosition.label = "Zapisane"
      }
  }

  private getNewContentType () {
    if (this.isUserLogged && !this.isAdmin)  {

      let authData = JSON.parse(localStorage.getItem('auth_data'));
      let lastLoginDate : Date = authData.user.lastLoginDate;

      this.topMenuService.getNewContentTypePublished(lastLoginDate).subscribe(
        response => {
          if (response.status != 1)
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie można pobrać danych");
          else {
            let newContentType = response.record;

            if (newContentType.length >0)
              this.topMenuService.getDictIdByContentTypeId(newContentType).subscribe(
                response => {
                  response.forEach(newContentType=>{
                    if (this.menuMarkedAsNew.indexOf(newContentType.dictId) === -1)
                      this.menuMarkedAsNew.push(newContentType.dictId)
                  })
                },
                error => {
                  console.log(error);
                  this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Wystąpił błąd! Nie można pobrać danych');
                }
              )
          }
        },
        error => {
          console.log(error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Wystąpił błąd! Nie można pobrać danych');
        }
      )
    }
  }

  private getSuggestions() {
    this.commonService.getSuggestions().subscribe(
      data => {
        if (data.status != 1) {
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania podpowiedzi do wyszukiwania');
        } else {
          this.searchItems = data.record;
        }
      },
      error =>{
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania podpowiedzi do wyszukiwania');
      }
    )
  }

  ngOnInit() {
    let authData = JSON.parse(localStorage.getItem('auth_data'));

    if (authData) {
      this.isUserLogged = true;
      this.isAdmin = authData.user.isAdmin;
      this.isClient = authData.user.isClient;

      if (this.isUserLogged){
        this.topMenuService.getMenuPositions(this.isAdmin).subscribe(
          (menuPositions: Array<MenuPosition>) => {
            this.menuPositions = menuPositions;

            if (this.activePosition !== -1) {
              this.menuPositionOnClick(this.activePosition);
              this.getNewContentType();
            }
          });

        }

        this.topMenuService.reloadSuggestions.subscribe(
          result=> {
            if (result ===  true)
              this.getSuggestions();
          }
        );

        this.getSuggestions();
    }


    this.topMenuService.clickMenuItem.subscribe((id)=>{
      this.menuPositionOnClick(id);
    });

    this.loginService.loginEvent.subscribe(
      (loginEvent:LoginEvent) => {

        this.isUserLogged = loginEvent.isUserLogged;
        this.isAdmin = loginEvent.isAdmin;
        this.isClient = loginEvent.isClient;
        this.activePosition = 0;

        if (this.isUserLogged) {
          this.topMenuService.getMenuPositions(this.isAdmin).subscribe(
            (menuPositions: Array<MenuPosition>) => {
              this.menuPositions = menuPositions;

              if (this.activePosition !== -1) {
                this.router.navigate([this.menuPositions[this.activePosition].link]);
                this.menuPositionOnClick(this.activePosition);

                this.getNewContentType();
              }
            });
          if (this.isClient)
            this.getSuggestions();

          if (loginEvent.sharedReportId){
            this.router.navigate(['shared-reports', loginEvent.sharedReportId]);
          }
          if (loginEvent.singleReportId) {
            this.router.navigate(['single-report', loginEvent.singleReportId]);
          }
        }
    });

    this.headerService.setFirstPositionOnTopMenu.subscribe( (signalToSetFirstPosition : boolean) => {
      if (signalToSetFirstPosition) {
        this.menuPositionOnClick(0);
      }
    });

    this.mainMenuService.deactivateTopMenuActivePosition.subscribe((deactivate : boolean) => {
      if (deactivate)
        this.activePosition = -1;
      else
        this.menuPositionOnClick(0);
    });

    this.singleReportService.deactivateTopMenuActivePosition.subscribe((deactivate : boolean) => {
      if (deactivate)
        this.activePosition = -1;
      else
        this.menuPositionOnClick(0);
    });

    this.userSuggestedReportsService.deactivateTopMenuActivePosition.subscribe((deactivate : boolean) => {
      if (deactivate)
        this.activePosition = -1;
      else
        this.menuPositionOnClick(0);
    });

    this.userSearchResultsService.deactivateTopMenuActivePosition.subscribe((deactivate : boolean) => {
      if (deactivate)
        this.activePosition = -1;
      else
        this.menuPositionOnClick(0);
    })
  }

  menuPositionOnClick(position : number) {

    if(this.menuPositions[position].label !== null){
      this.breadcumbsService.setSubfolder.emit(this.menuPositions[position].label);
    } else {
      this.breadcumbsService.setSubfolder.emit('Wszystkie raporty');
    }

    if (!this.menuPositions[position].forAdmin) {
      if (this.menuPositions[position].position_type == TopMenuPositionType.SAVED_REPORTS)
        this.router.navigate([this.menuPositions[position].link]).then((result:boolean) => {
          if (result || result === null) {
            this.searchItemsSelected = [];
            this.activePosition = position;
            this.topMenuService.menuPositionClickedEmit(this.menuPositions[position]);
          }
        });
      else
        this.router.navigate([this.menuPositions[position].link, this.menuPositions[position].contentTypeDictId]).then((result:boolean) => {
        if (result || result===null) {
          this.searchItemsSelected = [];
          this.activePosition = position;
          this.topMenuService.menuPositionClickedEmit(this.menuPositions[position]);
          let positionInMenuMarkedAsNew = this.menuMarkedAsNew.indexOf(this.menuPositions[position].contentTypeDictId);
          if (positionInMenuMarkedAsNew !== -1)
            this.menuMarkedAsNew.splice(positionInMenuMarkedAsNew,1 );
        }
      })
    }
    else {
      if (position === this.activePosition) {
        //Zmieniamy parametr, żeby za każdym kliknieciem byla inna wartosc i subskrypcja zauwazyla zmiane
        let min=1;let max=1000;
        let refreshPositions = Math.floor(Math.random() * (max - min + 1)) + min;
        this.router.navigate([this.menuPositions[position].link, refreshPositions]).then((result: boolean) => {
          if (result || result === null) {
            this.activePosition = position;
            this.topMenuService.menuPositionClickedEmit(this.menuPositions[position]);
          }
        });
      } else
        this.router.navigate([this.menuPositions[position].link, 0]).then((result:boolean) => {
          if (result || result===null) {
            this.activePosition = position;
            this.topMenuService.menuPositionClickedEmit(this.menuPositions[position]);
          }
        });
    }
  }

  protected menuPositionOnOver(position : number) {
    this.mouseOverPosition = position;
  }

  protected mouseLeaveMenuPosition() {
    this.mouseOverPosition = -1;
  }

  ngOnDestroy() {
    this.loginService.loginEvent.unsubscribe();
    this.mainMenuService.deactivateTopMenuActivePosition.unsubscribe();
    this.headerService.setFirstPositionOnTopMenu.unsubscribe();
    this.singleReportService.deactivateTopMenuActivePosition.unsubscribe();
    this.userSuggestedReportsService.deactivateTopMenuActivePosition.unsubscribe();
    this.userSearchResultsService.deactivateTopMenuActivePosition.unsubscribe();
  }

  protected onSelectSuggestion(searchItem: SearchItem) {
    let searchItems: Array<SearchItem> = [];
    // Przygotowane do wysłania wielu wartości
    if(searchItem) {
      searchItems.push(searchItem);
      this.router.navigate(['user-search-results/'+JSON.stringify(searchItems)], );
      this.topMenuService.changeSuggestionEmit(searchItems);
      this.searchItemsSelected=[];
    }

    this.activePosition = 0;
  }

  protected onClearSuggestions() {
    this.activePosition = 0;
  }

  protected getInstruction() {
    this.commonService.getInstruction().subscribe(
        data=> {
          saveAs(data, 'instrukcja użytkownika.pdf');
        },
        err => {
          console.log(err);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Wystąpił błąd! Nie można pobrać instrukcji użytkownika")
        }
    )
  }

  protected onRemoveCustomSearchItem(item: SearchItem, $event: MouseEvent) {
    event.stopPropagation();
    this.topMenuService.deleteUserSearchItem(item.id).subscribe(
        response => {
          if (response.status == 1)
            this.searchItems = this.searchItems.filter(searchItem => (searchItem.value !== item.value));

          console.log(response);
        },
        err => {
          console.log(err);
        });
  }

  protected addTag = (name: string): Promise<any> => {
    return new Promise((resolve, reject) => {
      this.topMenuService.createUserSearchItem(name).subscribe({
        next: response => {
          if (response.status === 1 && response.record) {
            const newSearchItem = {
              id: response.record.id,
              value: response.record.userTag,
              queryField: null,
              custom: true
            };
            this.searchItems.push(newSearchItem);
            resolve(newSearchItem); // ng-select doda tę wartość
          } else {
            reject(); // lub resolve(null);
          }
        },
        error: err => {
          console.error('Błąd przy tworzeniu tagu', err);
          reject(err);
        }
      });
    });
  }
}
